import Banner from "../Components/Shared/Layout/Banner";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import withLanguage from "../HOC/withLanguage";
import {AccordionBody, AccordionContainer, AccordionTitle} from "../Components/Shared/Layout/InstitutionAccordion";


const GjejDrejtimin = ({language}) => {
    return (
        <>
            <Banner img='/home-images/block1.jpg' title={language.banner}/>
            <IntroBlock>{language.introText}</IntroBlock>
            <p className="text-justify xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem] m-5">{language.description1}</p>
            <p className="text-justify xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem] m-5">{language.description2}</p>
            <p className="text-justify xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem] m-5">{language.description3}</p>

            <div className="text-justify m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <AccordionContainer panel="panel1">
                    <AccordionTitle title={language.title1} />
                </AccordionContainer>
                <AccordionContainer panel="panel2">
                    <AccordionTitle title={language.title2} />
                </AccordionContainer>
                <AccordionContainer panel="panel3">
                    <AccordionTitle title={language.title3} />
                </AccordionContainer>
                <AccordionContainer panel="panel4">
                    <AccordionTitle title={language.title4} />
                </AccordionContainer>
                <AccordionContainer panel="panel5">
                    <AccordionTitle title={language.title5} />
                </AccordionContainer>
            </div>

        </>
    )
}

export default withLanguage(GjejDrejtimin, "FindDirection")